module.exports = __webpack_public_path__ + "static/media/Karrablast_gaussian2.47edf17f.png";